import { useEffect, useState } from "react";
import ReactPortal from "../utils/protal";
import { CloseRounded } from "@mui/icons-material";
import Thumbnail from "../components/thumbnail";
import SpinLoader from "../components/spin-loader";
import axios from "axios";
import { API_URL } from "../utils/consts";
import "stream-engine-player/bundle";
import "stream-engine-player/style";


function Player({ item, widgetToken, onClose, apiUrl }) {
  const [settings, setSettings] = useState({
    defaultThumbnail: {
      url: "",
      apply: "none",
    },
  });

  let player;

  useEffect(() => {
    const fetchData = async () => {
      const { id: itemId } = item;
      try {
        const { data: result } = await axios.get(
          `${
            apiUrl || API_URL
          }/widgets/${widgetToken}?filter_by=${itemId}`
        );

        const { name } = result;
        const input = result?.content[0];
        const {
          id,
          src,
          state,
          type,
          name: videoTitle,
          tags,
          organizations,
          parent,
          recording_id,
          external_id,
          ad,
        } = input;

        const { logo, playback_control, style } = result?.player;
        const { position } = logo;
        const { skip_back_enable, skip_forward_enable, controls } =
          playback_control;
        const {
          id: workspaceId,
          name: workspaceName,
          token: workspaceToken,
          owner: workspaceOwner,
        } = organizations[0];
        const { url: adTagUrl } = ad;

        const { default_thumbnail } = result?.settings?.common || {};
        const logoSrc = default_thumbnail?.defaultSrc || "";
        const apply = default_thumbnail?.apply || "none";

        setSettings({
          defaultThumbnail: {
            url: logoSrc,
            apply,
          },
        });

        const playerProps = {
          src,
          logoSrc,
          controls,
          logoPosition: position,
          skipBack: skip_back_enable,
          skipForward: skip_forward_enable,
          style,
          adTagUrl,
          analytics: {
            playerName: name,
            videoId: id,
            videoTitle,
            videoTags: tags,
            videoState: state,
            videoType: type,
            videoParentId: parent ? parent?.id : null,
            workspaceId,
            workspaceToken,
            workspaceName,
            workspaceOwner,
            isRecording: !!recording_id,
            isExternal: external_id ? external_id : null,
          },
        };

        return playerProps;
      } catch (error) {
        console.error("Error fetching player data:", error);
      }
    };

    let init = async function () {
      const playerProps = await fetchData();
      player = window.streamEnginePlayer("player", playerProps);
    };
    init();
  }, [item, widgetToken, apiUrl, player]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const closeOnEscapeKey = (e) => (e.key === "Escape" ? onClose() : null);
    document.body.addEventListener("keydown", closeOnEscapeKey);
    return () => {
      document.body.removeEventListener("keydown", closeOnEscapeKey);
      document.body.style.overflow = "initial";
      player?.dispose();
      
    };
  }, [onClose, player]);
  return (
    <ReactPortal>
      <div className="vf-player fixed top-0 left-0 w-screen h-screen z-50 flex justify-center items-start md:items-center md:px-5">
        <div
          onClick={onClose}
          className="vf-player-backdrop absolute top-0 left-0 w-screen h-screen bg-[rgba(0,0,0,0.85)] z-10"
        ></div>
        <div className="flex flex-col w-full xl:w-2/3 z-20">
          <div className="flex justify-between py-2 px-1 bg-black md:bg-transparent md:px-0 md:py-0 md:mb-1 items-center">
            <span className="vf-player-title text-white font-bold text-sm sm:text-base md:text-lg mr-3">
              {item.name}
            </span>
            <div className="flex">
              <CloseRounded
                fontSize="medium"
                className="vf-player-close text-white/70 hover:text-white cursor-pointer"
                onClick={onClose}
              />
            </div>
          </div>
          <div className="w-full pt-16/9 relative bg-black overflow-hidden">
            <Thumbnail
              className="absolute top-0 left-0 opacity-50 blur-lg"
              item={item}
              settings={settings}
            />
            <SpinLoader className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50px] h-[50px]" />
            {/* <iframe
                src={`http://localhost:3002/widget/${widget}/player/${item.id}`}
                // src={`https://www.videoflow.io/widget/${widget}/player/${item.id}`}
                title="{data.name}"
                className="absolute w-full h-full top-0 left-0"
                allowFullScreen
              ></iframe> */}
            <div
              id="player"
              className="absolute top-0 left-0 w-full h-full"
            ></div>
          </div>
        </div>
      </div>
    </ReactPortal>
  );
}

export default Player;
